export const REPORT_TAB_TYPE = {
  SCORM: 'scorm',
  PERFORM: 'perform',
  BONUS_LIST: 'bonus_list',
  NEOFIN_TEAM_REPORT: 'neofin_team_report',
};

const REPORT_TAB_TYPES = Object.values(REPORT_TAB_TYPE);

export default { REPORT_TAB_TYPES };
